import { render, staticRenderFns } from "./PopupWorkingFiles.vue?vue&type=template&id=0046c846&scoped=true&"
import script from "./PopupWorkingFiles.vue?vue&type=script&lang=js&"
export * from "./PopupWorkingFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0046c846",
  null
  
)

export default component.exports